// removed by extract-text-webpack-plugin
module.exports = {"block":"O8TPb0BpWq5ZHgc8Rf1wG","inner":"L6O9dFf3Y0zTqYuWTdu__","outer":"_8JtVfRgsnkVjWFqDfzPDK","shown":"KFqHaWbNZq9t7vSXoddhC","icon":"_39GsWDUPktgPDfNm6rsmxX","tooltip":"_3bAHuyvWHpACcJ5jbKW0tk","tooltipIcon":"_3wtu7fQ4ozhyfHUNavWvzy","large":"_2nsWNUtJY2OvoJViA2omuH","link":"_3PXlwX4DfrjA-WpkUWFON2"};


//////////////////
// WEBPACK FOOTER
// ./src/components/CuriousBlock/CuriousBlock.module.scss
// module id = 745
// module chunks = 0